import type { Control, FieldValues, UseFormSetValue } from 'react-hook-form';

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../../components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import './Form.style.css';

interface SelectFormStep3Props {
  label?: string;
  placeholder?: string;
  options?: Array<string>;
  onClickOption: UseFormSetValue<FieldValues>;
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<FieldValues, any>;
}

export function SelectForm({ label, placeholder, options, name, onClickOption, control }: SelectFormStep3Props) {
  return (
    <FormField
      control={control}
      name="field"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            <p className="text-sh-xxs">{label}</p>
          </FormLabel>
          <Select
            onValueChange={(option) => {
              onClickOption(name, option);
            }}
            defaultValue={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {options?.map((option) => {
                return (
                  <SelectItem key={option} value={option}>
                    {option}
                  </SelectItem>
                );
              })}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
